<template>
  <div class="agreement">
    <div v-html="post_content" class="rich"></div>
  </div>
</template>

<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import { Toast } from 'vant';
  export default {
    data() {
      return {
        post_content:'',
        title: '',
      }
    },
    created: function() {
      this.title = this.$route.query.title
      document.title = this.title
      this.convert();
    },
    methods: {
      convert: function() {
          const type = this.$route.query.type;
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_wallet_agreement",{
          params:{ type:type }
        }).then(res =>{
          this.post_content = res.data.data.post_content;
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/agreement.vue